var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddToRoute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7297_202618)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46031 10.4374C8.46031 8.87734 9.73031 7.60734 11.2903 7.60734C12.8403 7.60734 14.1103 8.87734 14.1103 10.4374C14.1103 11.9874 12.8403 13.2574 11.2903 13.2574C9.73031 13.2574 8.46031 11.9874 8.46031 10.4374ZM19.0103 10.8674C19.1703 10.8674 19.3303 10.8774 19.4903 10.8874C19.5003 10.7574 19.5003 10.6274 19.5003 10.4974C19.5003 5.96734 15.8203 2.27734 11.2903 2.27734C6.76031 2.27734 3.07031 5.96734 3.07031 10.4974C3.07031 16.2674 9.82031 21.7274 11.2903 21.7274C11.8003 21.7274 12.9403 21.0674 14.2203 19.9674C13.5803 19.0274 13.2003 17.8974 13.2003 16.6774C13.2003 13.4674 15.8003 10.8674 19.0103 10.8674Z",
    fill: "#1080FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1774 15.4891H18.6424V13.9531C18.6424 13.5391 18.3064 13.2031 17.8924 13.2031C17.4784 13.2031 17.1424 13.5391 17.1424 13.9531V15.4891H15.6094C15.1954 15.4891 14.8594 15.8251 14.8594 16.2391C14.8594 16.6531 15.1954 16.9891 15.6094 16.9891H17.1424V18.5221C17.1424 18.9361 17.4784 19.2721 17.8924 19.2721C18.3064 19.2721 18.6424 18.9361 18.6424 18.5221V16.9891H20.1774C20.5914 16.9891 20.9274 16.6531 20.9274 16.2391C20.9274 15.8251 20.5914 15.4891 20.1774 15.4891Z",
    fill: "#1080FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46094 10.4375C8.46094 8.87742 9.73094 7.60742 11.291 7.60742C12.841 7.60742 14.111 8.87742 14.111 10.4375C14.111 11.9875 12.841 13.2575 11.291 13.2575C9.73094 13.2575 8.46094 11.9875 8.46094 10.4375Z",
    fill: "#1080FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7297_202618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToRoute);
export default __webpack_public_path__ + "static/media/add_to_route.8d8f8c61e9a5a4bcdf8bee6d64c38722.svg";
export { ForwardRef as ReactComponent };